export function queryToFilters (defaultFilters) {
  const copyOfDefaultFilters = JSON.parse(JSON.stringify(defaultFilters))

  const queryString = window.location.search.replace(/^\?/, '')

  const arr = queryString.split('&')
  if (arr.length === 0 || queryString === '') {
    return copyOfDefaultFilters
  }

  const query = {}
  arr.forEach(str => {
    const [k, v] = str.split('=')
    const key = decodeURIComponent(k)
    const value = decodeURIComponent(v)

    if (/,/.test(value)) {
      query[key] = value.split(/,/)
    } else {
      query[key] = value
    }
  })

  Object.keys(copyOfDefaultFilters).forEach(k => {
    if (query[k]) {
      if (Array.isArray(copyOfDefaultFilters[k]) && typeof query[k] === 'string') {
        copyOfDefaultFilters[k] = [query[k]]
      } else {
        copyOfDefaultFilters[k] = query[k]
      }
    }
  })
  return copyOfDefaultFilters
}

export function addParamsToLocation (route, params) {
  window.history.pushState(
    {},
    null,
    route.path +
    '?' +
    Object.keys(params).filter(key => params[key] || (params[key] && params[key].length > 0))
      .map(key => {
        return (
          encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        )
      })
      .join('&')
  )
}
